import { Route, Navigate, createBrowserRouter, createRoutesFromElements } from 'react-router-dom'
import AuthCallbackPage from './modules/Auth/providers/AuthSupabaseProvider/AuthCallback.container'
import DashboardPage from './pages/Dashboard'
import LandingPage from './pages/Landing'
import LoginSupabasePage from './pages/LoginSupabase'
import PrivacyPage from './pages/Privacy'
import TermsPage from './pages/Terms'
import NotFoundPage from './components/Pages/NotFound'
import PensionPage from './pages/Pension'
import routes, { LEGACY_PATH_REDIRECTS } from './config/settings/routes'
import PensionUserPage from './pages/PensionUsers'
import PensionCalculationPage from './pages/PensionCalculation'
import PensionLogsPage from './pages/PensionLogs'
import HelpPage from './pages/Help'
import SupportPage from './pages/Support'
import ProtectedByAuthentication from './modules/Auth/providers/AuthSupabaseProvider/AuthProvider.authentication'
import AddUtmPage from './pages/AddUtm'
import OnboardingPage from './pages/OnboardingPension'
import UserProfilePage from './pages/Preferences'
import ProtectedByOnboarding from './containers/Security/ProtectedByOnboarding'
import Error from './components/Pages/Error'

/**
 * The Routing's component.
 */
const routeComponents = [
  <Route errorElement={<Error />}>
    <Route path={routes.root} element={<LandingPage />} />
    <Route path={routes.landing} element={<Navigate to={routes.root} replace />} />

    <Route path={routes.login} element={<LoginSupabasePage />} />
    <Route path={routes.privacy} element={<PrivacyPage />} />
    <Route path={routes.terms} element={<TermsPage />} />
    <Route path={routes.register} element={<Navigate to={routes.login} replace />} />
    <Route path={routes.authCallback} element={<AuthCallbackPage />} />

    {/* Legacy English and /admin/* bookmarks → Spanish paths */}
    {LEGACY_PATH_REDIRECTS.map(([from, to]) => (
      <Route key={from} path={from} element={<Navigate to={to} replace />} />
    ))}

    {/* 🔐 PROTECTED AREA */}
    <Route element={<ProtectedByAuthentication />}>
      <Route path={routes.onboarding} element={<OnboardingPage />} />
      <Route element={<ProtectedByOnboarding />}>
        <Route path={routes.dashboard} element={<DashboardPage />} />
        <Route path={routes.preferences} element={<UserProfilePage />} />
        <Route path={routes.utm} element={<PensionPage />} />
        <Route path={routes.utmNew} element={<AddUtmPage />} />
        <Route path={routes.pensionUsers} element={<PensionUserPage />} />
        <Route path={routes.pensionUserDetail} element={<PensionUserPage />} />
        <Route path={routes.pensionCalculations} element={<PensionCalculationPage />} />
        <Route path={routes.logs} element={<PensionLogsPage />} />
        <Route path={routes.help} element={<HelpPage />} />
        <Route path={routes.support} element={<SupportPage />} />
      </Route>
      <Route path="*" element={<NotFoundPage />} />
    </Route>
  </Route>
]

const Routing = createBrowserRouter(createRoutesFromElements(routeComponents))

export default Routing
